import Login from './Login.json';

const it = {
  Login,
};

export default it;
